module.exports = "{{#each message}}\n{{#if date}}\n<div class=\"messages-date\">{{date}}</div>\n{{/if}}\n{{#if image}}\n<div class=\"message message-{{from}} message-pic \">\n    <div class=\"message-text\"><img src=\"{{text}}\"/></div>\n</div>\n{{else}}\n<div class=\"message message-{{from}} message-last\">\n    <div class=\"message-text\">{{text}}</div>\n</div>\n{{/if}}\n{{/each}}";


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/message/message.tpl.html
 ** module id = 46
 ** module chunks = 0
 **/